//@ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { Calendar, X, ChevronDown } from 'lucide-react';
import CalendarIcon from "../../assets/icons/CalendarIcon";
import { cn } from '../../utils/utils';
import ImageIcon from './ImageIcon';
import { useSelector } from 'react-redux';
type Props = {
  field: any;
  name: string;
  isDisabled?: boolean;
  label?: string;
  isRequired?: boolean;
  min?: string;
  title?:string;
  max?: string;
  customClass?:string;
  customLabelClass?:string;
  placeHolder?:string;
  handleChangeEvent:any;
  value?:string | null;
  dateInputProps?:any;

  
};
type rangeInfoType = {minMonth:string|number
        minYear:string|number
        maxMonth:string|number
        maxYear:string|number
    }
const MonthDate = (props:Props) => {
    const {placeHolder,customClass,handleChangeEvent,min,max} = props
    const [rangeInfo,setRangeInfo] = useState<rangeInfoType>({})
     const lang = useSelector((state: any) => state?.user?.lang);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null); // { month: number, year: number }
  
  const containerRef = useRef(null);

  // Close when clicking outside

  useEffect(() => {

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  useEffect(()=>{
    if(min && max){
      setRangeInfo({minYear:+min.split("-")[0],minMonth:+min.split("-")[1],maxYear:+max.split("-")[0],maxMonth:+max.split("-")[1]})
    }
  },[max,min])
  const handleSelect = (month, year) => {
    setSelectedDate({ month, year });
    handleChangeEvent(`${year}-${(month+1).toString().padStart(2,"0")}`);
    setIsOpen(false);
  };

  const clearSelection = () => {
    setSelectedDate(null);
    setIsOpen(false);
  };

  const selectCurrentMonth = () => {
    const now = new Date();
    setSelectedDate({ month: now.getMonth(), year: now.getFullYear() });
    setIsOpen(false);
  };

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr',
    'May', 'Jun', 'Jul', 'Aug',
    'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const formattedValue = selectedDate 
    ? `${months[selectedDate.month]} ${selectedDate.year}` 
    : placeHolder;

  return (
    <div className="  flex flex-col items-center justify-start   font-sans z-50">
      <div className="max-w-md w-full" ref={containerRef}>
       {props?.title &&  <label className="block text-sm font-medium text-gray-700 mb-1">{props?.title}</label>}
        
        {/* Trigger Input */}
        <div 
          onClick={() => setIsOpen(!isOpen)}
          className={cn("relative bg-white border border-gray-300 rounded-md px-4 py-2 flex items-center justify-between cursor-pointer hover:border-blue-400 transition-colors shadow-sm",customClass)}
        >
          <div className="flex items-center gap-2 text-gray-700">
            
            <span className={selectedDate ? 'text-gray-900' : 'text-gray-400'}>
              {formattedValue}
            </span>
             <ImageIcon
          Icon={CalendarIcon}
          className={`absolute ${
            lang == "ar" ? "left-1" : "right-1"
          }  top-2 w-7`}
        />
          </div>
         
        </div>

        {/* Picker Dropdown */}
        {isOpen && (
          <div className="absolute z-50 mt-2 w-full bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden animate-in fade-in zoom-in duration-150 origin-top-left">
            <MonthPickerContent 
              selectedDate={selectedDate} 
              onSelect={handleSelect}
              onClear={clearSelection}
              onCurrentMonth={selectCurrentMonth}
              months={months}
              rangeInfo={rangeInfo}
            />
          </div>
        )}
      </div>

     
    </div>
  );
};

const MonthPickerContent = ({ selectedDate, onSelect, onClear, onCurrentMonth, months,rangeInfo }) => {
  const currentYear = new Date().getFullYear();
  const starterYear = +rangeInfo?.minYear || currentYear-5;
  const maxYear = +rangeInfo?.maxYear+1 || currentYear+5;
  const [viewYear, setViewYear] = useState(selectedDate?.year || currentYear);
  
  // Create a range of years for the scrollable list
  const years = Array.from({ length: (maxYear-starterYear) }, (_, i) => starterYear + i);
  
  const yearListRef = useRef(null);
   const isValidMonth = (month:number)=>{
    if(viewYear === rangeInfo?.maxYear && month > rangeInfo?.maxMonth){
                    return false
    }else if(viewYear === rangeInfo?.minYear && month < rangeInfo?.minMonth){
                    return false
    }
    return true
   }
  // Auto-scroll to selected year on mount
  useEffect(() => {
    if (yearListRef.current) {
      const selectedEl = yearListRef.current.querySelector('[data-selected="true"]');
      if (selectedEl) {
        selectedEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div className="p-0 flex flex-col select-none z-50">
      {/* Year Selector List */}
      <div 
        ref={yearListRef}
        className="h-32 overflow-y-auto border-b border-gray-100 snap-y snap-mandatory scrollbar-hide"
      >
        {years.map((y) => (
          <div
            key={y}
            onClick={() => setViewYear(y)}
            data-selected={viewYear === y}
            className={`h-10 flex items-center px-4 cursor-pointer snap-start transition-colors
              ${viewYear === y ? 'bg-gray-100 text-gray-900 font-semibold' : 'text-gray-600 hover:bg-gray-50'}
            `}
          >
            {y}
          </div>
        ))}
      </div>

      {/* Months Grid */}
      <div className="p-4 grid grid-cols-4 gap-2">
        {months.map((month, index) => {
          const isSelected = selectedDate?.month === index && selectedDate?.year === viewYear;
          return (
            <button
              key={month}
              onClick={() =>{
                if(!isValidMonth(index)){
                    return
                }
                onSelect(index, viewYear)}}
              className={`
                h-10 rounded-sm flex items-center justify-center text-sm font-medium transition-all
                ${isSelected 
                  ? 'bg-[#007bff] text-white border-2 border-black' 
                  : 'text-black hover:bg-gray-50 hover:text-gray-800'
                } ${isValidMonth(index)?'':'cursor-not-allowed text-gray-400'}
              `}
            >
              {month}
            </button>
          );
        })}
      </div>

      {/* Action Footer */}
      <div className="px-4 py-3 flex items-center justify-between border-t border-gray-100 text-sm">
        <button 
          onClick={onClear}
          className="text-blue-500 hover:text-blue-600 font-medium"
        >
          Clear
        </button>
        <button 
          onClick={onCurrentMonth}
          className="text-blue-500 hover:text-blue-600 font-medium"
        >
          This month
        </button>
      </div>
    </div>
  );
};

export default MonthDate;